import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';

@Component({
  selector: 'app-add-inventory-manager',
  templateUrl: './add-inventory-manager.component.html',
  styleUrls: ['./add-inventory-manager.component.css']
})
export class AddInventoryManagerComponent implements OnInit {
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    // This will disable dates starting from tomorrow
  };
  uploadDir: string = environment.uploadDir;
  @ViewChild('fileInput') fileInput;
  selectedOption: string;
  uploads_name: any = {};
  model: any;
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {
    cert_details: []
  };
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  savecertList: any;
  fieldName: string;
  fileList: FileList;
  certId: any;
  fileU: boolean;
  formedata: FormData;
  onlyview: boolean = false;
  options: any;
  getuintofmeasurement: any;
  formdata: FormData;
  upname: any;
  targetfile: any;
  inventory_manager_id: any;
  headerLabel: string;
  appSug: any;
  rows: any = [];
  product_id: boolean;
  inv_items: any;
  backUrl: string;
  headerLabel1: any;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService

  ) {
    this.uploads_name.inventory_manager_upload_path = {
      file_name: '',
      file_temp_name: '',
    };
    this.appSug = { inventory_item_name: '' };
    this.model = {
      inventory_type: '',
      cost_method: 'f',
      serial_num: [],
      inventory_item_id: '',
      unit_of_measurement: '',
      file_name: '',
      distype: '',
      file_temp_name: '',
      gst_value: ''
    };
    this.loginservice.getuintofmeasurement().subscribe(data => {
      this.getuintofmeasurement = data['getuintofmeasurement'];
    },
      error => {
        alert('Network Error getuintofmeasurement API');
      });


  }
  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this._arout.params.subscribe(p => {
      if (p.view_id) {
        this.onlyview = true;

      }

      if (p.product_id) {
        this.backUrl = "/inventory-manager/" + p.product_id
        if (p.product_id === 1 || p.product_id === '1') {
          this.headerLabel1 = 'Fixed';
        } else if (p.product_id === 2 || p.product_id === '2') {
          this.headerLabel1 = 'Product';
        } else if (p.product_id === 3 || p.product_id === '3') {
          this.headerLabel1 = 'Usable';
        }
        this.model.inventory_item_id = p.product_id
        this.product_id = true;
      }

      this.loginservice.getInventoryItem('',).subscribe(data => {
        this.inv_items = data['comp_details'];
      },
        error => {
          alert('Network Error getInventoryItem API');
        });


      if (p.inventory_manager_id) {
        this.headerLabel = 'Edit';
        this.inventory_manager_id = p.inventory_manager_id
        this.getInventorymanager(p.inventory_manager_id);
      } else {
        this.headerLabel = 'Add';
        // this.getInventorymanager('');
      }

    },
      error => {
        alert('Network Error params API');
      });

  }


  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => this.searching = true)
      .switchMap(term =>
        this.loginservice.getInventoryItemterm(term, this.currentUser)
          .map(response => <string[]>response['comp_details'])
          .do(() => this.searchFailed = false)
          .catch(() => {
            this.searchFailed = true;
            return Observable.of([]);
          }))
      .do(() => this.searching = false)
      .merge(this.hideSearchingWhenUnsubscribed)
  formatter = (x: { inventory_item_name: string }) => x.inventory_item_name;

  asignModel(n) {

    if (this.inventory_manager_id) {

      this.model = {
        ...this.model,
        inventory_item_id: n.inventory_item_id,
        inventory_item_name: n.inventory_item_name,
        unit_of_measurement: '',
        serial_num: []
      };

    } else {
      if (typeof n === 'object') {
        this.model = n;
        this.model.unit_of_measurement = '';
        this.model.serial_num = [] // Initialize as an empty array

      }

      // this.Emp_Id = n.id;
      // if (typeof this.app.interview_date !== 'object') {
      //   this.app.interview_date = this._common.strToDates(n.interview_date);
      // }      

    }
  }



  getInventorymanager(inventory_manager_id) {
    this.loginservice.getInventorymanagersAddEdit(inventory_manager_id, this.currentUser).subscribe(data => {
      if (data['status'] == 'success') {
        if (inventory_manager_id) {
          this.appSug = { inventory_item_name: data['inventory_item_name'] };
          this.model = data;
          // if (data['file_name'] != '' && data['file_temp_name'] != '') {
          //   this.uploads_name.inventory_manager_upload_path = {
          //     file_name: data['file_name'],
          //     file_temp_name: data['file_temp_name'],
          //   };
          // }
          this.addrows(this.model['quantity_on_hand'])
        }
        this.showLoader = false;

      } else {
        // this.model = [];
        this.model = {
          inventory_type: 'si',
          cost_method: 'f'
        };
        // this._flashMessagesService.show('No Vendors!', { cssClass: 'alert-danger' });
        // this.router.navigate(['addlowertier']);
        this.showLoader = false;
      }

    },
      error => {
        alert('Network Error getInventorymanagersAddEdit API');
        this.showLoader = false;
      });
  }


  saveinventorymanager() {
    this.showLoader = true;
    this.loginservice.saveinventorymanager(this.model, 'fixed', '', this.inventory_manager_id, this.currentUser)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
            this.showLoader = false;

            if (this.targetfile) {
              this.uploadmanager(this.formdata, this.upname, data['inventory_manager_id'])
            } else {
              this.router.navigate(['/inventory-manager/' + this.model.inventory_item_id]);
            }
          } else {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
            this.showLoader = false;
          }
        },
        error => {
          alert('Network Error saveinventorymanager API');
        });
  }


  upload(f, name) {

    if (f.target.files[0]) {
      const formData = new FormData();
      formData.append(name, f.target.files[0]);
      this.formdata = formData;
      this.upname = name;
      this.targetfile = f.target.files[0];
      this.uploads_name.inventory_manager_upload_path = { file_name: f.target.files[0].name };


    }
  }

  uploadmanager(formData, name, inventory_manager_id) {
    this.loginservice.uploadFile1(formData, name, inventory_manager_id, '', 'id', 'inventory_manager').subscribe(r => {
      if (r['status'] === 'success') {
        var path_name = name + '_path';
        this.uploads_name[path_name] = r;
        this.router.navigate(['/inventory-manager/' + this.model.inventory_item_id]);
      } else {
        this._flashMessagesService.show(r['message'], { cssClass: 'alert-danger' });
        this.router.navigate(['/inventory-manager/' + this.model.inventory_item_id]);
      }
    },
      error => {
        alert('Network Error uploadmanager API');
        this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        this.router.navigate(['/inventory-manager/' + this.model.inventory_item_id]);
      });
  }

  clearAll() {
    this.model = {};
    this.appSug = '';
  }

  deleteupload() {
    if (confirm('Deleting of this inventory item is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deleteupload(this.inventory_manager_id, 'id', 'inventory_manager').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.uploads_name.inventory_manager_upload_path = {
            file_name: '',
            file_temp_name: '',
          };
          this.model['file_name'] = '';
          this.model['file_temp_name'] = '';
        },
          error => {
            alert('Network Error deleteupload API');
            this.showLoader = false;
          });
      }
    }
  }



  addrows(value) {
    this.rows = [];

    // Regular expression to check for pure integers
    const pureIntegerRegex = /^[0-9]+$/;

    // Regular expression to check for pure strings (alphabets only)
    const pureStringRegex = /^[a-zA-Z]+$/;

    // Check if the value is a pure integer
    if (pureIntegerRegex.test(value)) {

      // this.model.serial_num = [] // Initialize serial_num as an empty array
      // Value is a valid number
      for (let index = 0; index < value; index++) {
        // Add rows logic here
        this.rows.push(index)
      }
    }
    // Check if the value is a pure string
    else if (pureStringRegex.test(value)) {
      this.model['tot_cost'] = this.model['amt_per'] = this.model['quantity_on_hand'] = '';
    }
    // Check if the value is a mix of both integer and string
    else if (/^[a-zA-Z0-9]+$/.test(value)) {
      this.model['tot_cost'] = this.model['amt_per'] = this.model['quantity_on_hand'] = '';
    }
    // If none of the above, then it contains special characters
    else {
      this.model['tot_cost'] = this.model['amt_per'] = this.model['quantity_on_hand'] = '';
      console.error('Invalid value. Please provide a valid number.');
    }
  }

  calculate() {
    this.model['dis_price'] = 0;
    this.model['gst'] = 0;
    this.model['gst_value'] = '';
    // Regular expression to check for pure integers
    const pureIntegerRegex = /^[0-9]+$/;

    // Regular expression to check for pure strings (alphabets only)
    const pureStringRegex = /^[a-zA-Z]+$/;

    // Check if the value is a pure integer
    if (pureIntegerRegex.test(this.model['amt_per'])) {
      if (this.model['quantity_on_hand']) {
        this.model['tot_costForCal'] = this.model['tot_cost'] = this.model['amt_per'] * this.model['quantity_on_hand']
      } else {
        this.model['tot_costForCal'] = this.model['tot_cost'] = this.model['amt_per'] = this.model['quantity_on_hand'] = '';
        this.rows = [];
      }
    }
    // Check if the value is a pure string
    else if (pureStringRegex.test(this.model['amt_per'])) {
      this.model['tot_costForCal'] = this.model['tot_cost'] = this.model['amt_per'] = this.model['quantity_on_hand'] = '';
      this.rows = [];
    }
    // Check if the value is a mix of both integer and string
    else if (/^[a-zA-Z0-9]+$/.test(this.model['amt_per'])) {
      this.model['tot_costForCal'] = this.model['tot_cost'] = this.model['amt_per'] = this.model['quantity_on_hand'] = '';
      this.rows = [];
    }
    // If none of the above, then it contains special characters
    else {
      if (this.model['quantity_on_hand']) {
        this.model['tot_costForCal'] = this.model['tot_cost'] = this.model['amt_per'] * this.model['quantity_on_hand']
      } else {
        this.model['tot_costForCal'] = this.model['tot_cost'] = this.model['amt_per'] = this.model['quantity_on_hand'] = '';
        this.rows = [];
      }
    }

  }

  onDateChanged(type, event: IMyDateModel): void {
    // date selected
    if (type === 'month') {
      this.model['getmonth'] = event;

    } else {
      this.model['getyear'] = event;
    }
  }

  CheckPhone(value, name) {
    // Regular expression to check for pure integers
    const pureIntegerRegex = /^[0-9]+$/;

    // Regular expression to check for pure strings (alphabets only)
    const pureStringRegex = /^[a-zA-Z]+$/;

    // Check if the value is a pure integer
    if (pureIntegerRegex.test(value)) {

    }
    // Check if the value is a pure string
    else if (pureStringRegex.test(value)) {
      this.model[name] = '';
      this._flashMessagesService.show('Invalid Number', { cssClass: 'alert-danger' });
      // alert('Invalid Number');
    }
    // Check if the value is a mix of both integer and string
    else if (/^[a-zA-Z0-9]+$/.test(value)) {
      this.model[name] = '';
      this._flashMessagesService.show('Invalid Number', { cssClass: 'alert-danger' });
      // alert('Invalid Number');
    }
    // If none of the above, then it contains special characters
    else {
      this.model[name] = '';
      this._flashMessagesService.show('Invalid Number', { cssClass: 'alert-danger' });
      // alert('Invalid Number');
    }
  }

  updateRowTotal(value) {
    this.model['gst'] = 0;
    if (value) {
      this.calculateDiscountNew();
      if (this.model['amt_per'] > 0) {
        // this.model['gst'] = (this.model['tot_cost'] * value) / 100;
        this.model['gst'] = ((this.model['amt_per'] * this.model['quantity_on_hand']) * value) / 100;
        this.model['tot_cost'] = this.model['tot_cost'] + (this.model['tot_cost'] * value) / 100;
      }
    } else {
      this.model['gst'] = 0;
      this.model['gst_value'] = '';
      this.calculateDiscountNew();
    }
  }

  calculateDiscountNew() {
    const pureIntegerRegex = /^[0-9]+$/;
    const pureStringRegex = /^[a-zA-Z]+$/;
    if (this.model['dis_price'] === '' || this.model['dis_price'] === 0) {
      this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand'])
    }
    if (pureIntegerRegex.test(this.model['dis_price'])) {
      let cost = 0;
      let originalCost = this.model['tot_costForCal']
      if (this.model['tot_costForCal']) {
        if (this.model['distype'] == 'amount') {
          if (this.model['tot_costForCal'] > this.model['dis_price']) {
            cost = (this.model['amt_per'] * this.model['quantity_on_hand']) - this.model['dis_price'];
          } else {
            this.model['dis_price'] = 0;
            this.model['distype'] = '';
            this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
          }
        } else {
          cost = ((this.model['amt_per'] * this.model['quantity_on_hand']) / 100) * this.model['dis_price'];
        }
      } else {
        cost = (this.model['amt_per'] * this.model['quantity_on_hand'])
        this.model['dis_price'] = 0;
        this.model['distype'] = '';
        this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
      }
      if (this.model['tot_costForCal'] > cost) {
        if (this.model['distype'] == 'amount') {
          this.model['tot_cost'] = cost;
        } else {
          this.model['tot_cost'] = originalCost - cost;
        }
      } else {
        this.model['dis_price'] = 0;
        this.model['distype'] = '';
        this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
      }
    }
    else if (pureStringRegex.test(this.model['dis_price'])) {
      this.model['dis_price'] = 0;
      this.model['distype'] = '';
      this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
    }
    else if (/^[a-zA-Z0-9]+$/.test(this.model['dis_price'])) {
      this.model['dis_price'] = 0;
      this.model['distype'] = '';
      this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
    }
    else {
      this.model['dis_price'] = 0;
      this.model['distype'] = '';
      this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
    }
  }

  calculateDiscount() {
    this.model['gst'] = 0;
    this.model['gst_value'] = '';
    // Regular expression to check for pure integers
    const pureIntegerRegex = /^[0-9]+$/;

    // Regular expression to check for pure strings (alphabets only)
    const pureStringRegex = /^[a-zA-Z]+$/;

    if (this.model['dis_price'] === '' || this.model['dis_price'] === 0) {
      this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand'])
    }
    // Check if the value is a pure integer
    if (pureIntegerRegex.test(this.model['dis_price'])) {

      let cost = 0;
      let originalCost = this.model['tot_costForCal']
      if (this.model['tot_costForCal']) {
        if (this.model['distype'] == 'amount') {
          if (this.model['tot_costForCal'] > this.model['dis_price']) {
            cost = (this.model['amt_per'] * this.model['quantity_on_hand']) - this.model['dis_price'];
          } else {
            this.model['dis_price'] = 0;
            this.model['distype'] = '';
            this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
          }

        } else {
          cost = ((this.model['amt_per'] * this.model['quantity_on_hand']) / 100) * this.model['dis_price'];
        }

      } else {
        cost = (this.model['amt_per'] * this.model['quantity_on_hand'])
        this.model['dis_price'] = 0;
        this.model['distype'] = '';
        this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
      }
      if (this.model['tot_costForCal'] > cost) {
        if (this.model['distype'] == 'amount') {
          this.model['tot_cost'] = cost;
        } else {
          this.model['tot_cost'] = originalCost - cost;
        }
      } else {
        this.model['dis_price'] = 0;
        this.model['distype'] = '';
        this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
      }

    }
    // Check if the value is a pure string
    else if (pureStringRegex.test(this.model['dis_price'])) {
      this.model['dis_price'] = 0;
      this.model['distype'] = '';
      this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
    }
    // Check if the value is a mix of both integer and string
    else if (/^[a-zA-Z0-9]+$/.test(this.model['dis_price'])) {
      this.model['dis_price'] = 0;
      this.model['distype'] = '';
      this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
    }
    // If none of the above, then it contains special characters
    else {
      this.model['dis_price'] = 0;
      this.model['distype'] = '';
      this.model['tot_cost'] = (this.model['amt_per'] * this.model['quantity_on_hand']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/add-inventory-manager/add-inventory-manager.component.ts